import React from "react";

// Components
import Button from "components/UiKit/Button";
import Accordion from "components/UiKit/Accordion";

// Lib
import { shallowEqual } from "react-redux";
import { useAppSelector } from "lib/hooks/useDispatch";

export const Status: React.FC = () => {
  const ebcId = useAppSelector(
    (store) => store.moleculeProduct.data.id,
    shallowEqual
  );

  const handlerClickSds = () => {
    const url = `https://enamine.enamine.net/pub/msds?code=${ebcId}&&senderid=0&&lang=en`;

    window.open(url, "_blank");
  };

  return (
    <div className="product-datasheets molecule-product__accordion mb5">
      <Accordion
        isOpen={true}
        title="Product datasheets"
        className="molecule-product__border-accordion"
        classNameContent="molecule-product__accordion-width"
      >
        <div className="product-datasheets__block-sdf flex flex-ai-center">
          <Button
            isSvg
            color="blue"
            variable="icon"
            className="mr10"
            icon="sdfBlueSvg"
            disabled={!ebcId}
            onPress={handlerClickSds}
          />
          <p className="product-datasheets__label">SDS</p>
        </div>
      </Accordion>
    </div>
  );
};

export default Status;